@if (items$ | async; as items) {
  <div
    class="relative flex h-full w-screen select-none flex-row items-center overflow-y-auto"
    data-testid="comparison-scroll"
    (wheel)="onWheel($event)">
    @for (item of items; track trackByGalleryItem(item); let index = $index) {
      <div class="relative h-full min-w-[33%]">
        <pxc-comparison-gallery-item
          class="h-full"
          [attr.data-testid]="'comparison-' + index"
          [item]="item"
          [ngClass]="items.length < 3 ? 'image-' + items.length : 'image-infinite'"
          (loadError)="onPictureError(item)" />
        <ng-template #insertionAnchors />
      </div>
    }
  </div>

  <!-- Action bar -->
  <pxc-action-buttons
    class="absolute right-3 top-3 flex flex-wrap gap-1"
    data-testid="actions"
    defaultAppearance="glass"
    hintDirection="bottom"
    size="m"
    [actionButtons]="galleryActionButtons"
    [actions]="galleryMenuActions"
    [entity]="items"
    [iconOnly]="true" />
} @else {
  <pxc-loader class="block h-full" data-testid="items-loading" [dark]="true" />
}
